/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

// ---------------------------
// AUTO-GENERATED. DO NOT EAT.
// ---------------------------

import {
  ProjectId,
  isProjectId,
  TeamId,
  isTeamId,
} from "../core/types.generated";
import {
  ProjectEmailSettings,
  isProjectEmailSettings,
  ProjectMapSettings,
  isProjectMapSettings,
} from "../project/types.generated";

export interface Team {
  name: string;
  projectId: ProjectId;
  mapSettings?: ProjectMapSettings | null;
  emailSettings: ProjectEmailSettings;
  id: TeamId;
}

export const isTeam = (v: any): v is Team => {
  return (
    typeof v === "object" &&
    v != null &&
    "name" in v &&
    typeof v.name === "string" &&
    "projectId" in v &&
    isProjectId(v.projectId) &&
    (!("mapSettings" in v) ||
      isProjectMapSettings(v.mapSettings) ||
      v.mapSettings === null) &&
    "emailSettings" in v &&
    isProjectEmailSettings(v.emailSettings) &&
    "id" in v &&
    isTeamId(v.id)
  );
};

/* eslint-enable @typescript-eslint/explicit-module-boundary-types */
/* eslint-enable @typescript-eslint/no-use-before-define */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable @typescript-eslint/no-explicit-any */
/* eslint-enable @typescript-eslint/no-empty-interface */
